import { FC } from 'react';
import { LabelTransformer, DiffBase, DiffBaseProps } from '../diff-base';
import * as Styled from './dictionary-candidate-preoffer-info-diff.styles';
import { useTranslation } from 'react-i18next';
import { DictionaryCandidatePreofferInfoDataFields } from '@innowise-group/core';

interface DictionaryCandidatePreofferInfoDiff extends Omit<DiffBaseProps, 'labelTransformer'> {
  fieldName: DictionaryCandidatePreofferInfoDataFields;
}

const DictionaryCandidatePreofferInfoDiff: FC<DictionaryCandidatePreofferInfoDiff> = (props) => {
  const { fieldName } = props;
  const labelTransformer: LabelTransformer<typeof fieldName> = ({ data }, index) => {
    const { t } = useTranslation();

    return (
      <Styled.OptionWrapper key={index}>
        <Styled.LabelAndValueWrapper>
          <Styled.Value>{data?.translation || t('buttons.leaveBlank')}</Styled.Value>
        </Styled.LabelAndValueWrapper>
      </Styled.OptionWrapper>
    );
  };
  return <DiffBase labelTransformer={labelTransformer} {...props} />;
};

export default DictionaryCandidatePreofferInfoDiff;
